import React from 'react';

const DocumentPaperLetter = ({ children, style, className }) => {
  return (
    <div
      style={{
        ...styles.preview,
        ...style,
      }}
      className={`shadow ${className}`}
    >
      {children}
    </div>
  );
};

export default DocumentPaperLetter;

export const letter = {
  WIDTH: 21.59,
  HEIGHT: 27.94 - 0.06,
};

const styles = {
  preview: {
    backgroundColor: 'white',
    fontSize: '11pt',
    maxWidth: `${letter.WIDTH}cm`,
    minWidth: `${letter.WIDTH}cm`,
    width: `${letter.WIDTH}cm`,
    minHeight: `${letter.HEIGHT}cm`,
    // maxHeight: `${letter.HEIGHT}cm`,
    // height: `${letter.HEIGHT}cm`,
    padding: '2cm',
    margin: 0,
  },
};
